let config = require("../../../config/web");


/**
 * 百分比
 * @param data 
 * @param num 
 */
export function toPercent(data: any, num?: any): string {
  if (data === '' || data === null || isNaN(data)) {
    return '-';
  }
  num = isNaN(parseInt(num)) ? 2 : parseInt(num);
  // let fh = data >= 0 ? "+" : "";
  let fh = data > 0 ? "+" : "";
  return !isNaN(parseFloat(data)) ? fh + parseFloat(data).toFixed(num) + '%' : '-';
}


/**
 * 获取颜色
 * @param data 判断的字段数据
 * @param arr 得到的数据组
 */
export function getColor(data: any, arr?: Array<string>): string {
  if (!arr || arr.length != 3) {
    arr = ['text-red', 'text-green', '']
  }
  data = parseFloat(data);
  return !!data ? (data == 0 ? '' : data > 0 ? arr[0] : arr[1]) : arr[2];
}


/**
 * 通过路演状态获取html
 * @param type 
 */
export function getLuyanStatus(type: number, istest: boolean): string {
  if (istest) return "";
  switch (type) {
    case 1:
      return `<span id="lystatustag" class="tag zhibo">直播中</span>`;  //<span id="lystatustag" class="tag zhibo">LIVE</span>  //直播不展示
    case 3:
      return `<span id="lystatustag" class="tag huigu">回顾</span>`;
    case 4:
      return `<span id="lystatustag" class="tag yugao">预告</span>`;
    default:
      return '';
  }
}


/**
 * 节流
 * @param fn 
 * @param delay 
 */
export function debounce(fn: Function, delay: number = 500) {
  let timer: any = null;
  return function (this: any) {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * 解读低版本浏览器 时间格式化bug
 * @param dateStringInRange 2019-11-05 13:23:05 
 */
function parseISO8601(dateStringInRange: string) {
  let isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*(\d{1,2}):(\d{1,2}):(\d{1,2})\s*$/,
    // let isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
    date = new Date(NaN), month,
    parts: any = isoExp.exec(dateStringInRange);
  if (parts) {
    month = +parts[2];
    date.setFullYear(parts[1], month - 1, parts[3]);
    date.setHours(parts[4] || 0, parts[5] || 0, parts[6] || 0);
    if (month != date.getMonth() + 1) {
      date.setTime(NaN);
    }
  }
  return date;
}

/**
 * 格式化时间
 * @param date 时间
 * @param part 格式 yyyy-MM-dd HH:mm:ss
 */
export function dateFormat(str: any, part?: string): string {
  let date: any = new Date(str);
  if (isNaN(date)) {
    date = parseISO8601(str);
  }
  var redate = "";
  part = (part == null) ? "yyyy-MM-dd" : part;
  let y: any = date.getFullYear();
  let M: any = date.getMonth() + 1;
  let d: any = date.getDate();
  let H: any = date.getHours();
  let m: any = date.getMinutes();
  let s: any = date.getSeconds();
  let MM: any = (M > 9) ? M : "0" + M;
  let dd: any = (d > 9) ? d : "0" + d;
  let HH: any = (H > 9) ? H : "0" + H;
  let mm: any = (m > 9) ? m : "0" + m;
  let ss: any = (s > 9) ? s : "0" + s;
  redate = part.replace("yyyy", y).replace("MM", MM).replace("dd", dd).replace("HH", HH).replace("mm", mm).replace("ss", ss).replace("M", M).replace("d", d).replace("H", H).replace("m", m).replace("s", s);
  return redate;
}

/*
 *@description:
 *@modifyContent:genghuan
 *@author: qiuhongyang
 *@date: 2020-07-15 13:26:29
 *
*/
export function showface(html: string) {
  var facearr = ["微笑", "大笑", "鼓掌", "为什么", "哭", "怒", "滴汗", "俏皮", "傲", "好困惑", "兴奋", "加油", "困顿", "想一下", "撇嘴", "色", "发呆", "得意", "害羞羞", "大哭", "呲牙", "惊讶", "囧", "抓狂", "偷笑", "愉快", "憨笑", "晕", "再见", "坏笑", "左哼哼", "右哼哼", "哈欠", "委屈", "快哭了", "亲", "可怜", "口罩", "笑哭", "惊吓", "哼", "捂脸", "奸笑", "吃瓜", "旺柴", "围观", "摊手", "爱心", "献花", "福", "拜神", "胜利", "赞", "握手", "抱拳", "勾引", "拳头", "OKOK", "强壮", "毛估估", "亏大了", "赚大了", "牛", " ", "成交", "财力", "护城河", "复盘", "买入", "卖出", "满仓", "空仓", "抄底", "看多", "看空", "加仓", "减仓", "上涨", "下跌", "财神", "火箭", "龙头", "韭菜", "面", "泡沫", "惨!关灯吃面"];
  var re = new RegExp('\\[[^ \f\n\r\t\v<>]+?\\]', "ig");
  html = html.replace(re, function (item) {
    for (var i = 0; i < facearr.length; i++) {
      if ("[" + facearr[i] + "]" == item) {
        return '<img title="' + facearr[i] + '" src="//gbfek.dfcfw.com/face/emot_default_28x28/emot' + (i + 1) + '.png" alt="' + item + '" class="article_icon">';
      }
    }
    return item;
  });

  return html;
}


/**
 * 获取排序名次颜色
 * @param index 名次
 */
export function getRankClass(index: number): string {
  let className = '';

  switch (index) {
    case 1: className = 'r_red'; break;
    case 2: className = 'r_orange'; break;
    case 3: className = 'r_yellow'; break;
  }

  return className;
}


/**
   * 获取url search参数
   * @param name 名称
   */
export function getQueryParams(name: string) {
  var urlpara = location.search;
  var par: any = {};
  if (urlpara != "") {
    urlpara = urlpara.substring(1, urlpara.length);
    var para = urlpara.split("&");
    var parname;
    var parvalue;
    for (var i = 0; i < para.length; i++) {
      parname = para[i].substring(0, para[i].indexOf("="));
      parvalue = para[i].substring(para[i].indexOf("=") + 1, para[i].length);
      par[parname] = parvalue;
    }
  }
  if (typeof (par[name]) != "undefined") {
    return par[name];
  }
  else {
    return null;
  }
}

/**
 * 路演时间处理
 * ps:仅限路演特殊处理
*/

export function formatshowtime(begin: any, end: any) {
  let back = "";
  try {
    //当前时间
    let curTime = new Date();
    let cy = curTime.getFullYear();
    let cm: any = (curTime.getMonth() + 1) < 10 ? '0' + (curTime.getMonth() + 1) : curTime.getMonth() + 1;
    let cd: any = curTime.getDate();
    let c_d = cd < 10 ? '0' + cd : cd;//当前日
    let c_ym = cy + '' + cm; //当前年月
    //开始时间
    let b_ymd = begin.split('T')[0];
    let b_ym = b_ymd.substr(0, 7).replace('-', "");
    let b_hs = begin.split('T')[1].substr(0, 5);
    //结束时间
    let e_ymd = end.split('T')[0];
    let e_ym = e_ymd.substr(0, 7).replace('-', "");
    let e_hs = end.split('T')[1].substr(0, 5);

    let b_d = b_ymd.split('-')[2];
    let e_d = e_ymd.split('-')[2];

    if (b_ymd == e_ymd) { //如果开始和结束是同一天,且和当前时间同年同月
      if (c_d == e_d && c_ym == e_ym) {
        e_ymd = '今天'
      }
      back = e_ymd + ' ' + b_hs + '-' + e_hs
    } else {
      back = b_ymd + ' ' + b_hs + ' - ' + e_ymd + ' ' + e_hs
    }
  } catch (error) {

  }
  return back
}
/**
 *
 *
 * @export 获取字符串长度
 * @param {string} val
 * @returns
 */
export function getStrLength(val: string) {
  try {
    var len = 0;
    for (var i = 0; i < val.length; i++) {
      var a = val.charAt(i);
      if (a.match(/[^\x00-\xff]/ig) != null) {
        len += 2;
      }
      else {
        len += 1;
      }
    }
    return len;
  } catch (error) {
    return 0
  }
}

/**
 * 截取指定长度字符串
 * @param str 
 * @param L 
 * @returns 
 */
export function cutStrByLen(str: any, L: number) {
  var result = '',
    strlen = str.length, // 字符串长度
    chrlen = str.replace(/[^\x00-\xff]/g, '**').length; // 字节长度

  if (chrlen <= L) { return str; }

  for (var i = 0, j = 0; i < strlen; i++) {
    var chr = str.charAt(i);
    if (/[\x00-\xff]/.test(chr)) {
      j++;
    } else {
      j += 2;
    }
    if (j <= L) {
      result += chr;
    } else {
      return result;
    }
  }

}


/**
 * 图片大小处理
 * 按宽度等比缩放：?imageMogr2/thumbnail/宽度x
 * 按高度等比缩放：?imageMogr2/thumbnail/x高度
 * 
 * ?imageMogr2/auto-orient/thumbnail/500x
 */
export function formatImgUrl(url: string, width?: number, height?: number) {
  if (!url) return "";

  let imgstr = url.replace("http://", "https://");
  let w = width ? width : 500, h = height ? height : 400;

  if ((imgstr).indexOf("https://emav-") > -1 || (imgstr).indexOf("https://cover-") > -1) {
    imgstr += `?imageMogr2/thumbnail/${w}x`
  };

  return imgstr
}

/**
 * 直播类型转换
 * @param status 
 * @returns 
 */
export let getLiveStatus = (status: number) => {
  if (!status) return "";
  switch (status) {
    case 1:
      return {
        txt: `直播中`,
        type: "zb"
      };
    case 3:
      return {
        txt: `回顾`,
        type: "hg"
      }
    case 4:
      return {
        txt: `预告`,
        type: "yg"
      }
    default:
      return {
        txt: ``,
        type: ``
      };
  }
}

/**
 * 头部菜单格式化
 * @param res 
 * @returns 
 */
export let formatConfigHeaderData = (res: any = []) => {
  let arr: any = []
  if (!res || res.length < 1) {
    return arr;
  };

  // console.log(res)
  //.filter((v:any)=> v.sub_data_set.length>0)
  arr = res.map((v: any) => {
    return {
      column_name: v.column_name,
      column_id: v.column_id,
      path: `/list?type=${v.column_id}`,
      isexact: false,
      sub_data_set:v.sub_data_set
    }
  });

  arr.unshift({
    column_name: "首页",
    column_id: "",
    path: "/",
    isexact: true,
    sub_data_set:[]
  });

  return arr;
};